import React from 'react';
import { Tag } from '@amzn/storm-ui';
import { MobileHelpTagWrapper } from './styles';

const GlobalAccountTooltipAlertMobile = () => {
  return (
    <MobileHelpTagWrapper>
      <Tag variant="info" label="New" />
    </MobileHelpTagWrapper>
  );
};
export default GlobalAccountTooltipAlertMobile;
